import { render, staticRenderFns } from "./bankahareketleri.vue?vue&type=template&id=09d1fc42&"
import script from "./bankahareketleri.vue?vue&type=script&lang=js&"
export * from "./bankahareketleri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports